module.exports = __webpack_public_path__ + "static/media/Brios-Cereales-Descripcion-Mobile.fa5b4e65.webp";